import { getAuth } from 'firebase/auth';

/**
 * Get the current user's ID token with forced refresh
 * @returns {Promise<string|null>} The ID token or null if no user is logged in
 */
export const getIdToken = async () => {
  const auth = getAuth();
  const user = auth.currentUser;
  
  if (!user) {
    throw new Error('No authenticated user found');
  }
  
  try {
    return await user.getIdToken();
  } catch (error) {
    console.error('Error getting ID token:', error);
    throw error;
  }
};

/**
 * Check if the current user is authenticated
 * @returns {boolean} True if a user is logged in
 */
export const isAuthenticated = () => {
  const auth = getAuth();
  return !!auth.currentUser;
};

/**
 * Get the current user's ID
 * @returns {string|null} The user ID or null if no user is logged in
 */
export const getUserId = () => {
  const auth = getAuth();
  return auth.currentUser?.uid || null;
};

/**
 * Wait for authentication to be ready
 * @returns {Promise<void>}
 */
export const waitForAuth = () => {
  const auth = getAuth();
  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });
};

export default {
  getIdToken,
  isAuthenticated,
  getUserId,
  waitForAuth
}; 